import { render, staticRenderFns } from "./commerce.vue?vue&type=template&id=8d9182c0&scoped=true&"
import script from "./commerce.vue?vue&type=script&lang=js&"
export * from "./commerce.vue?vue&type=script&lang=js&"
import style0 from "./commerce.vue?vue&type=style&index=0&id=8d9182c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9182c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d9182c0')) {
      api.createRecord('8d9182c0', component.options)
    } else {
      api.reload('8d9182c0', component.options)
    }
    module.hot.accept("./commerce.vue?vue&type=template&id=8d9182c0&scoped=true&", function () {
      api.rerender('8d9182c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/commerce.vue"
export default component.exports